<script>
import FormsDiscountsBaseSave from '@/components/forms/discounts/FormsDiscountsBaseSave'
export default {
  extends: FormsDiscountsBaseSave,

  props: {
    receiptObject: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    receipt: null,
    entityUuid: null
  }),

  watch: {
    receiptObject: {
      immediate: true,
      handler (receiptObject) {
        this.receipt = Object.assign({}, receiptObject)
        this.entityUuid = receiptObject.uuid
        if (receiptObject.discountType) {
          this.form.chosenDiscountType = receiptObject.discountType
        }
        if (receiptObject.discountValue) {
          this.form.chosenDiscountValue = receiptObject.discountValue
        }
      }
    }
  },

  methods: {
    addStaffDiscount () {
      this.$wait.start('saving discount')
      return this.$store.dispatch('RECEIPT/ADD_RECEIPT_DISCOUNT_STAFF')
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally((data) => this.$wait.end('saving discount'))
    },
    removeDiscount (receiptUuid) {
      this.$wait.start('saving discount')
      return this.$store.dispatch('RECEIPT/REMOVE_RECEIPT_DISCOUNT', { receiptUuid })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.form.chosenDiscountType = this.form.chosenDiscountValue = null
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => {
          this.$wait.end('saving discount')
        })
    },
    submit () {
      if (!this.validate()) return
      this.$wait.start('saving discount')
      return this.$store.dispatch('RECEIPT/ADD_RECEIPT_DISCOUNT', {
        discountType: this.form.chosenDiscountType,
        discountValue: this.form.chosenDiscountValue
      })
        .then((data) => {
          this.$wait.end('saving discount')
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
        }).catch((data) => {
          this.$wait.end('saving discount')
          if (data && data.message) this.helpers.toastError(data.message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/discounts/FormsDiscountsReceiptSave.vue